import TourTypeSection from "./TourTypeSection";

export default TourTypeSection;
